import React, { useState } from "react";
import DatePicker from "react-datepicker";

import DateUtil from "../../common/dateUtil";
import CheckboxList from "../common/controls/CheckboxList";

const PreTradeSearchCriteriaComp = (props) => {
  let initFromDate = new Date(new Date());
  initFromDate.setDate(initFromDate.getDate() - 90);

  const initFormData = {
    securitySymbol: "",
    securityDesc: "",
    brokerDealerId: [""],
    tradeActions: "",
    account: "",
    fromDate: initFromDate,
    toDate: new Date(),
    reqStatus: "",
    securityTypes:""
  };

  const [tradeActions, setTradeActions] = useState([
    { name: "tradeAction_B", key: "B", label: "Buy", checked: true },
    { name: "tradeAction_S", key: "S", label: "Sell", checked: true },
    { name: "tradeAction_SS", key: "SS", label: "Sell Short", checked: true }
  ]);

  const [reqStates, setReqStates] = useState([
    { name: "reqState_Approved", key: "APPROVED", label: "Approved", checked: true },
    { name: "reqState_Pending", key: "PENDING", label: "Pending", checked: true },
    { name: "reqState_Rejected", key: "REJECTED", label: "Rejected", checked: true },
    { name: "reqState_Cancelled", key: "CANCELLED", label: "Cancelled", checked: true }
  ]);


const [securityTypes,setSecuriytTypes] = useState([
  { name: "securityType_Equity", key: "Equity", label: "Equity", checked: true},
  { name: "securityType_Bond", key: "Bond", label: "Bond", checked: true},
  { name: "securityType_Option", key: "Option", label: "Option", checked: true},
  { name: "securityType_MutualFund", key: "MutualFund", label: "Mutual Fund", checked: true},
  { name: "securityType_Alternative", key: "Alternative", label: "Alternative", checked: true},
  { name: "securityType_PrivateInvestment", key: "PrivateInvestment", label: "Private Investment", checked: true},
])

  const [formData, setFormData] = useState(initFormData);

  const [validation, setValidation] = useState({
    valid:true,
    tradeAction: true,
    reqStatus: true,
    securityType:true
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value.trim(),
    });

  };

  const handleReqStateChange = (e) => {
    const itemName = e.target.name;
    const isChecked = e.target.checked;
    setReqStates((p) => {
      return p.map((item) => {
        return item.name === itemName ? { ...item, checked: isChecked } : item;
      });
    });
  };

  const handleTradeActionChange = (e) => {
    const itemName = e.target.name;
    const isChecked = e.target.checked;
    setTradeActions((p) => {
      return p.map((item) => {
        return item.name === itemName ? { ...item, checked: isChecked } : item;
      });
    });
  };

  const handleSecurityTypeChange = (e)=>{
    const itemName = e.target.name;
    const isChecked = e.target.checked;
    setSecuriytTypes((p) => {
      return p.map((item) => {
        return item.name === itemName ? { ...item, checked: isChecked } : item;
      });
    });
  }

  const handleFinInstituteChange = (e) => {
    let el = e ? e.target : this._select;
    let selectedValues = [];
    for (let i = 0, l = el.options.length; i < l; i++) {
      if (el.options[i].selected) {
        selectedValues.push(el.options[i].value);
      }
    }
    if (e || String(formData.brokerDealerId) !== String(selectedValues)) {
      setFormData({
        ...formData,
        brokerDealerId: selectedValues,
      });
    }
  };

  const handleFromDateChange = (date) => {
    setFormData({ ...formData, fromDate: date });
  };

  const handleToDateChange = (date) => {
    setFormData({ ...formData, toDate: date });
  };

  const getCheckedStr = (obj) => {
    const selected = obj.filter((p) => {
      return p.checked === true;
    });

    const ta = selected.map((p) => {
      return p.key;
    });

    return ta.join();
  };

  const validateForm = (strAction, strStatus, strSecurityTypes) => {
    const valid = strAction && strStatus && strSecurityTypes ? true : false;
    setValidation({
      ...validation,
      valid,
      tradeAction: strAction ? true : false,
      reqStatus: strStatus ? true : false,
      securityType: strSecurityTypes ? true : false,
    });
    console.log(validation);
    return valid;
  };

  const handleSearchClick = () => {
    const actionsStr = getCheckedStr(tradeActions);
    const statesStr = getCheckedStr(reqStates);
    const securityTypesStr = getCheckedStr(securityTypes);

    if (!validateForm(actionsStr, statesStr,securityTypesStr)) {
      return;
    }

    let fromDate = DateUtil.toIsoStrDate(formData.fromDate);
    let toDate = DateUtil.toIsoStrDate(formData.toDate);

    let jsonData = {
      ...formData,
      tradeActions: actionsStr,
      reqStatus: statesStr,
      securityTypes:securityTypesStr,
      fromDate: fromDate,
      toDate: toDate,
    };
    props.onSearch(jsonData);
  };

  return (
    <div className="form">
      <div className="form-header">
        <div className="form-header-label">Filter & Display</div>
      </div>
      <div className="form-body">
        <div className="form-items">

          <div className="form-columns">
            <div className="form-column">

              <div className="form-item">
                <label className={`form-item-label required ${validation.securityType ? "" : "warning"}`}>
                  Security Type:
                </label>

                <div className="form-item-value label-group">
                  <CheckboxList items={securityTypes} handleChange={handleSecurityTypeChange}/>
                </div>
              </div>

              <div className="form-item">
                <label className="form-item-label" htmlFor="securitySymbol">
                  Security Symbol:
              </label>
                <input
                  className="form-item-value"
                  type="text"
                  id="securitySymbol"
                  name="securitySymbol"
                  value={formData.securitySymbol}
                  onChange={handleChange}
                />
              </div>


              <div className="form-item">
                <label className="form-item-label" htmlFor="account">
                  Account Number:
              </label>
                <input
                  className="form-item-value"
                  type="text"
                  id="account"
                  name="account"
                  value={formData.account}
                  onChange={handleChange}
                />
              </div>

              <div className="form-item">
                <label className="form-item-label" htmlFor="finInstitute">
                  Financial Institutions:
              </label>
                <select
                  multiple
                  className="form-item-value"
                  name="finInstituteId"
                  value={formData.brokerDealerId}
                  onChange={handleFinInstituteChange}
                >
                  <option key="" value="">
                    (All)
                </option>
                  {props.metadata.finInstitute &&
                    props.metadata.finInstitute.map((fin) => (
                      <option key={fin.id} value={fin.id}>
                        {fin.name}
                      </option>
                    ))}
                  <option key="Other" value="Other">
                    Other
                </option>
                </select>
              </div>



            </div>

            <div className="form-column">

              <div className="form-item">
                <label className={`form-item-label required ${validation.tradeAction ? "" : "warning"}`}>
                  Trade Action:
                </label>

                <div className="form-item-value label-group">
                  <CheckboxList items={tradeActions} handleChange={handleTradeActionChange}/>
                </div>
              </div>


              <div className="form-item">
                <label className={`form-item-label required ${validation.reqStatus ? "" : "warning"}`}>
                  Request Status:
                </label>

                <div className="form-item-value label-group">
                  <CheckboxList items={reqStates} handleChange={handleReqStateChange}/>
                </div>
              </div>

              <div className="form-item splitted">
                <div className="flex flex-1 mr-3">
                  <label className="form-item-label-short">From Date:</label>
                  <div className="form-item-value-short">
                    <DatePicker
                      selected={formData.fromDate}
                      onChange={handleFromDateChange}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                  </div>
                </div>

                <div className="flex flex-1">
                  <label className="form-item-label-short">To Date:</label>
                  <div className="form-item-value-short">
                    <DatePicker
                      selected={formData.toDate}
                      onChange={handleToDateChange}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                  </div>
                </div>
              </div>


            </div>




          </div>

        </div>
      </div>
      <div className="form-footer">
        {validation.valid ? (
          <div className="form-status"></div>
        ) : (
            <div className="form-status error">Enter Required Information</div>
          )}

        <div className="btn-group">
          <button
            id="btnLoadProductDetail"
            type="button"
            className="btn btn-primary"
            onClick={handleSearchClick}
          >
            Search
          </button>
        </div>
      </div>
    </div>
  );
};

export default PreTradeSearchCriteriaComp;
